import React from 'react';

import { Typography, TypographyProps } from '@mui/material';

import IsoTimestamp from 'src/types/IsoTimestamp';

import useDurationLabel from './useDurationLabel';

export { default as useDurationLabel } from './useDurationLabel';

type Props = {
  timestamp: IsoTimestamp;
  typographyProps?: TypographyProps;
};

const DurationLabel = ({ timestamp, typographyProps }: Props) => {
  const durationLabel = useDurationLabel(timestamp);

  return <Typography {...typographyProps}>{durationLabel}</Typography>;
};

export default DurationLabel;
